import axios from "axios";

import AxiosInstance from "axios";  

export const LOGIN_URL = "api/auth/login";
export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";

export const ME_URL = "api/me";

export function login(email, password) {
  // return axios.post( LOGIN_URL, { email, password });
  return AxiosInstance.post("/api/v1/admin/users/sign-in", { email, password })
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email, url) {
  // return axios.post(REQUEST_PASSWORD_URL, { email }); 
  return AxiosInstance.post('/api/v1/admin/users/forgot-password' , {email , url});
}

export function resetPassword(newPassword, token) { 
  return AxiosInstance.post('/api/v1/admin/users/reset-password' , {newPassword, token});
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}
